module.exports = __webpack_public_path__ + "img/toggle-chat.51e31664.png";